import api from '../../auth/apiClient';
import { ComparisonResponse, EstateOption, DivisionOption, PemanenOption } from '../types';

export class ComparisonApiService {
    /**
     * Fetch comparison data between Mutu Buah (Jejak) and Sakti BCC
     */
    static async fetchComparison(
        estateId?: number, 
        divisionId?: number, 
        pemanenName?: string, 
        date?: string,
        comparisonType?: string,
        discrepancies?: string[],
        differenceStatus?: string
    ): Promise<ComparisonResponse> {
        const response = await api.get<ComparisonResponse>(
            '/api/report/inspection/mutu-buah-comparison/details', 
            {
                params: {
                    estate_id: estateId,
                    division_id: divisionId,
                    pemanen_name: pemanenName,
                    comparison_type: comparisonType,
                    discrepancies: discrepancies,
                    difference_status: differenceStatus,
                    inspection_date: date
                },
                paramsSerializer: {
                    indexes: null
                }
            }
        );
                 
        // console.log(response);
        return response.data;
    }

    /**
     * Fetch filter options (estates and divisions) from /inspeksi/options
     */
    static async fetchFilterOptions(): Promise<{
        estates: EstateOption[];
        divisis: DivisionOption[];
        pemanens: PemanenOption[];
    }> {
        const response = await api.get<{
            estates: EstateOption[];
            divisis: DivisionOption[];
            pemanens: PemanenOption[];
        }>('/inspeksi/options');
        return response.data;
    }
}
